$ ->
  return unless $('body').is('.videos-index-page')

  $('.info-expand-and-collapse-button').on 'click', ->
    # scroll to subject headline if videos get collapsed
    unless $(this).is('.collapsed')
      $('html, body').animate
        scrollTop: $(this).parent().offset().top - ($('.page-header').height() || 0)
      , 500

    # build 'more videos' from data attribute (seo requirement)
    if $(this).prev().find('a').length is 4
      $listElement = $(this).parent().parent().find('ul')
      data         = $listElement.data('videos')

      $.each data, (key, value) ->
        clone = $listElement.find('.list-video-meta__item').first().clone().appendTo($listElement)
        clone.find('a').attr 'href', value.video_path
        clone.attr 'data-video-id', value.video_id
        clone.find('.list-video-meta__title span').text value.video_title
        clone.find('img').attr
          src: value.image_path
          alt: value.video_title
        clone.find('.list-video-meta__icon--duration span').text value.duration

      # Add video eyes to new generated elements
      Sofatutor.filterVideos('.list-video-meta > .list-video-meta__item', watchedVideoIds).addClass 'is-watched' if typeof watchedVideoIds isnt 'undefined'
